// src/utils/packageExampleCounts.js — how many examples an install or an
// add-on added later would bring (keepr-api KPR-465), worked out from what a
// package listing or GET …/add-ons serves: counts only, never an example.
// keepr-api KPR-1265: an example that waits on several add-ons is counted
// under their keys joined by "+", and comes only once every one of them is
// there. Pure; re-exported by src/services/packages.js, where it began.

/**
 * How many examples an install would bring: a bundle's core and the add-ons
 * `selected`, in the example sets of the listing it was opened from — added
 * up from the listing row's `examples.counts` (counts by group and set, never
 * an example). Any other package (or an API from before KPR-465): all of its
 * items, as the dialog always said.
 */
export function exampleCountFor(pkg, selected, listingKey) {
	const counts = Array.isArray(pkg?.examples?.counts) ? pkg.examples.counts : null;
	if (!counts) return pkg?.contents?.items || 0;
	const listing = (pkg?.listings || []).find(l => l.key === listingKey) || null;
	const sets = listing && Array.isArray(listing.examples) ? listing.examples : null;
	const chosen = new Set(selected || []);
	// keepr-api KPR-1265: an example that waits on several add-ons is counted
	// under their keys joined by "+", and comes only when every one is ticked.
	const comes = addOn => (String(addOn).includes('+') ? String(addOn).split('+').every(k => chosen.has(k)) : chosen.has(addOn));
	return counts
		.filter(c => (c.addOn === null || c.addOn === undefined || comes(c.addOn)))
		.filter(c => !sets || !(c.sets || []).length || c.sets.some(k => sets.includes(k)))
		.reduce((n, c) => n + (c.count || 0), 0);
}

/**
 * The examples the add-ons `keys` would bring to a collection that holds the
 * bundle (GET …/add-ons' `items`), and (keepr-api KPR-1265) those that two or
 * more of them complete together, when every one is ticked (`jointItems`).
 */
export function addLaterExampleCount(held, keys) {
	const want = new Set(keys || []);
	const own = (held?.addOns || []).filter(a => want.has(a.key)).reduce((n, a) => n + (a.items || 0), 0);
	const together = (Array.isArray(held?.jointItems) ? held.jointItems : [])
		.filter(j => Array.isArray(j?.addOns) && j.addOns.length && j.addOns.every(k => want.has(k)))
		.reduce((n, j) => n + (Number(j.items) || 0), 0);
	return own + together;
}
